var _line, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 32,
    viewBox: "0 0 745 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 15.5,
    x2: 745,
    y2: 15.5001,
    stroke: "#7C63A4",
    strokeOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 32,
    transform: "translate(338)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.835 21.126C352.116 21.126 351.463 20.9627 350.875 20.636C350.296 20.3093 349.839 19.8473 349.503 19.25C349.176 18.6433 349.013 17.9433 349.013 17.15C349.013 16.366 349.181 15.6753 349.517 15.078C349.862 14.4713 350.329 14.0093 350.917 13.692C351.505 13.3653 352.163 13.202 352.891 13.202C353.619 13.202 354.277 13.3653 354.865 13.692C355.453 14.0093 355.915 14.4667 356.251 15.064C356.596 15.6613 356.769 16.3567 356.769 17.15C356.769 17.9433 356.592 18.6433 356.237 19.25C355.892 19.8473 355.42 20.3093 354.823 20.636C354.226 20.9627 353.563 21.126 352.835 21.126ZM352.835 20.006C353.292 20.006 353.722 19.8987 354.123 19.684C354.524 19.4693 354.846 19.1473 355.089 18.718C355.341 18.2887 355.467 17.766 355.467 17.15C355.467 16.534 355.346 16.0113 355.103 15.582C354.86 15.1527 354.543 14.8353 354.151 14.63C353.759 14.4153 353.334 14.308 352.877 14.308C352.41 14.308 351.981 14.4153 351.589 14.63C351.206 14.8353 350.898 15.1527 350.665 15.582C350.432 16.0113 350.315 16.534 350.315 17.15C350.315 17.7753 350.427 18.3027 350.651 18.732C350.884 19.1613 351.192 19.4833 351.575 19.698C351.958 19.9033 352.378 20.006 352.835 20.006ZM359.718 14.574C359.942 14.1353 360.26 13.7947 360.67 13.552C361.09 13.3093 361.599 13.188 362.196 13.188V14.504H361.86C360.432 14.504 359.718 15.2787 359.718 16.828V21H358.444V13.328H359.718V14.574Z",
    fill: "#2F2F2F",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerLine);
export default __webpack_public_path__ + "static/media/divider-line.276b69e71de9c87b8fdb1bd1b0ea4008.svg";
export { ForwardRef as ReactComponent };